import { SentryService } from '@ianesthesie-kit/sentry';
import {
  ErrorApiResponse,
  ErrorDetails,
  isErrorDetails
} from '@ianesthesie-kit/services';
import axios, { AxiosError } from 'axios';

export function setupAxiosInterceptors() {
  axios.interceptors.response.use(
    (resp) => resp,
    (error: AxiosError<ErrorApiResponse>) => {
      if (isErrorDetails(error?.response?.data?.error)) {
        const requestBody = error?.config?.data;
        const { debug } = error?.response?.data.error as ErrorDetails;

        // don't capture all exceptions here
        // prepare breadcrumb to be captured when needed
        SentryService.getInstance().addBreadcrumb({
          level: 'error',
          type: 'api',
          data: { debug, requestBody }
        });
      }

      return Promise.reject(error);
    }
  );
}
